function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.585 29.0625C19.2449 29.0625 23.0225 25.2849 23.0225 20.625C23.0225 15.9651 19.2449 12.1875 14.585 12.1875C9.92506 12.1875 6.14746 15.9651 6.14746 20.625C6.14746 25.2849 9.92506 29.0625 14.585 29.0625Z",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4375 15.9375V20.625L17.1875 23.4375",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9737 19.705C24.361 19.2553 25.5685 18.3747 26.4206 17.1912C27.2726 16.0077 27.7248 14.5832 27.7112 13.125C27.6682 10.6538 26.6585 8.2979 24.8987 6.5625C24.8455 6.99703 24.7051 7.41633 24.4858 7.79525C24.2666 8.17416 23.973 8.50487 23.6228 8.76754C23.2726 9.0302 22.8729 9.2194 22.4478 9.32379C22.0226 9.42818 21.5808 9.44559 21.1487 9.375C19.953 8.36972 19.1214 6.99872 18.7825 5.47373C18.4437 3.94875 18.6163 2.35461 19.2737 0.9375C13.4137 0.9375 9.66372 4.395 8.96122 9.375C8.09672 9.46527 7.23003 9.22566 6.53467 8.70414C5.83932 8.18263 5.36662 7.41769 5.21122 6.5625C0.506218 10.5625 1.64497 17.8663 6.19747 19.7088",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTimeClockFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockFire);
export default __webpack_public_path__ + "static/media/time-clock-fire.9231edcc.svg";
export { ForwardRef as ReactComponent };